import { useState, useRef, useCallback } from 'react';

export const useTurnstile = () => {
  const [token, setToken] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);

  const turnstileRef = useRef(null);
  const resolverRef = useRef(null);

  const handleVerify = useCallback((newToken) => {
    setToken(newToken);
    setIsVerifying(false);

    if (resolverRef.current) {
      resolverRef.current(newToken);
      resolverRef.current = null;
    }
  }, []);

  const handleExpire = useCallback(() => {
    setToken(null);
  }, []);

  const execute = useCallback(() => {
    if (!turnstileRef.current) return Promise.resolve(null);

    setIsVerifying(true);

    return new Promise((resolve) => {
      resolverRef.current = resolve;
      turnstileRef.current.execute();
    });
  }, []);

  const reset = useCallback(() => {
    if (turnstileRef.current) {
      turnstileRef.current.reset();
      setToken(null);
    }
  }, []);

  return {
    token,
    isVerifying,
    execute,
    reset,
    handleVerify,
    handleExpire,
    turnstileRef
  };
};
